
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarketSituation from "@/components/MarketSituation";
import Solution from "@/components/Solution";
import Features from "@/components/Features";
import Actors from "@/components/Actors";
import Awards from "@/components/Awards";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Arbitrinity = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Handle hash navigation if present
    if (location.hash) {
      // Remove the # character and get the section id
      const sectionId = location.hash.substring(1);
      const element = document.getElementById(sectionId);
      
      if (element) {
        // Add a small delay to ensure the page has fully loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
    
    // Initialize intersection observer for reveal-on-scroll elements
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    // Observe all elements with reveal-on-scroll class
    document.querySelectorAll(".reveal-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => {
      // Clean up on component unmount
      document.querySelectorAll(".reveal-on-scroll").forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, [location]); // Added location as a dependency

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <SEO
        title="Arbitrinity — BlueTech energia management platform"
        description="Az Arbitrinity intelligens energia management platform a napelemes és tárolós rendszerek optimalizálására, a piaci arbitrázs kihasználására."
        path="/arbitrinity"
        type="product"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Arbitrinity",
          description: "Intelligens energia management platform napelemes és energiatárolós rendszerekhez, piaci arbitrázs optimalizálással.",
          brand: { "@type": "Brand", name: "BlueTech Energy Solutions" },
          url: "https://bluetech.lovable.app/arbitrinity"
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <MarketSituation />
        <Solution />
        <Features />
        <Actors />
        <Awards />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Arbitrinity;
